export const MAX_POST_ATTACHMENTS = 8;
export const MAX_POST_ATTACHMENT_SIZE_MB = Number(process.env.REACT_APP_POST_ATTACHMENT_MAX_SIZE_MB || 15);
export const ACCEPTED_POST_ATTACHMENT_TYPES = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'image/webp',
];
